import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import ScheduleList from '../../components/schedule/ScheduleList';
import Button from '../../components/common/Button';
import Card from '../../components/common/Card';
import { useTeam } from '../../hooks/useTeam';
import Spinner from '../../components/common/Spinner';

const TeamSchedulesPage: React.FC = () => {
  const { teamId } = useParams<{ teamId: string }>();
  const { team, isLoading } = useTeam(teamId);

  if (isLoading || !teamId) {
    return <Spinner />;
  }

  return (
    <div className="container mx-auto py-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">
          {team?.name ? `${team.name} Schedules` : 'Team Schedules'}
        </h1>
        <Link to={`/teams/${teamId}/schedules/new`}>
          <Button variant="primary" leftIcon={<PlusIcon size={16} />}>
            New Schedule
          </Button>
        </Link>
      </div>

      <div className="py-6">
        <Card>
          <div className="px-4 py-5 sm:p-6">
            <ScheduleList teamId={teamId} />
          </div>
        </Card>
      </div>
    </div>
  );
};

export default TeamSchedulesPage; 